import {Base64} from 'js-base64';
import BTCookies from '../../common/cookies';
import {BTTrackerBase} from './base';
import {TOPIC_IP_DATA} from '../messagehub/topics';
import {fetchIpData} from '../../vendor/ipData';
import {EventTypes} from '../events';
import {trackersPush} from '../utils';
import {CACHED_LOCATION_COOKIE} from '../ccpa/index';

export class IpDataTracker extends BTTrackerBase {
  getName() {
    return 'IpDataTracker';
  }

  async init() {
    const topic = TOPIC_IP_DATA;

    try {
      const cookie = BTCookies.get(CACHED_LOCATION_COOKIE);
      // ccpa sets the cookie (src/trackers/ccpa/index.js)
      // to get the actual value (ie, the ip info), we need to reverse how the cookie was set
      const message = cookie ? JSON.parse(Base64.decode(cookie)) : await fetchIpData();

      this.messageHub.publish({topic, message});

      trackersPush(trackerManager => {
        trackerManager.event(EventTypes.IP_ADDRESS_INFO, {message});
      });

      this.log('IpData initialized');
      return true;
    } catch (err) {
      this.logError(err);
      return false;
    }
  }
}
